/* @flow */
import styled from "styled-components";

const StyledAudio = styled.audio`
  box-sizing: border-box;
  width: 100%;
`;

export default StyledAudio;
